import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://55fc8932018a512a08429c8a291d464c@o4508200844328960.ingest.us.sentry.io/4508200859140096",
  environment: import.meta.env.PUBLIC_ENV_NAME,
});
